import { CanvasStage } from "./canvas-stage";
import { ToolBar } from "./toolbar/tool-bar";
import { AppMenu } from "./controls/app-menu";
import { PresenceList } from "./controls/presence-list";
import { MiniMap } from "./minimap/mini-map";
import { ShortcutTipsPanel } from "../../components/shortcut-tips-panel";
import { useCanvasBootstrap } from "./use-canvas-bootstrap";
import { useRealtimeConnection } from "../../realtime/use-realtime-connection";
import { RealtimeClientProvider } from "../../realtime/realtime-context";

interface Props {
  readonly canvasId: string;
}

// /c/:canvasId 配下の全画面レイアウト。
// - REST bootstrap でスナップショットを doc store にロード
// - WebSocket でサーバ op を購読
// - 子コンポーネントは RealtimeClientProvider 経由で sendOp を呼べる
//
// 存在しない canvasId でもクライアント側で空キャンバスとして開始する（lazy create）。
export function CanvasView({ canvasId }: Props): JSX.Element {
  useCanvasBootstrap(canvasId);
  const realtime = useRealtimeConnection(canvasId);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        overflow: "hidden",
        background: "var(--color-bg)",
      }}
    >
      {realtime.client ? (
        <RealtimeClientProvider client={realtime.client}>
          <CanvasStage canvasId={canvasId} />
          <AppMenu canvasId={canvasId} />
          <PresenceList />
          <ToolBar />
          <MiniMap />
          <ShortcutTipsPanel />
        </RealtimeClientProvider>
      ) : null}
      {realtime.status === "error" ? (
        <div
          role="alert"
          style={{
            position: "absolute",
            top: 16,
            left: "50%",
            transform: "translateX(-50%)",
            background: "var(--color-surface)",
            border: "1px solid var(--color-border)",
            padding: "8px 16px",
            borderRadius: "var(--radius-2)",
            boxShadow: "var(--shadow-1)",
            color: "var(--color-text-muted)",
            fontSize: "12px",
            zIndex: 100,
          }}
        >
          リアルタイム接続に失敗しました。再読み込みをお試しください。
        </div>
      ) : null}
    </div>
  );
}
